import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  .box1{
    flex: 2;
    background: #010883;

    width: 100%;
    height: 100vh;
    padding: 20px;

    display: flex;
    align-items: start;
    justify-content: space-between;
    flex-direction: column;
    
    img {
      width: 600px;
    }

    .box-description {
      display: flex;
      flex-direction: column;
      gap: 10px;

      h2 {
        color: #FFF;
      }

      strong {
        color: #FFF;
      }
    }
  }

  .box2{
    flex: 1;
    padding: 15px;

    h2 {
      margin-bottom: 10px;
    }

    form {
      display: flex;
      align-items: start;
      justify-content: center;
      flex-direction: column;
      gap: 5px;

      input {
        width: 70%;
        height: 35px;
        border: 1px solid #7f8c8d;
        border-radius: 5px;
        padding: 10px;
        font-size: 15px;
      }
      
      button {
        width: 120px;
        height: 35px;
        background: #010883;
        color: #FFF;
        border: 0;
        border-radius: 5px;
        font-size: 15px;
        font-weight: 500;
        margin-top: 20px;
        text-decoration: none;
        
        display: flex;
        align-items: center;
        justify-content: center;

        transition: filter 0.4s;

        &:hover{
          filter: brightness(0.6);
        }
      }
    }

    p {
      margin-top: 10px;
    }
  }

  @media(max-width: 720px){
    .box1 {
      flex: 1;
      align-items: start;

      img {
        width: 200px;
      }
    }
  }
`